import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicDMA = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Direct Memory Access (DMA)"
      videos={[
        "https://www.youtube.com/embed/gGB-X3KmAZU"
      ]}
      takeaways={[
        { text: "Learn about all the modes of transfer." },
        { text: "Understand all diagrams related to DMA." },
        { text: "This is the most important topic from this module." }
      ]}
      questions={[]} // No questions provided
      exampleVideos={[]} // No example videos provided
    />
);
}

export default ModuleSubtopicDMA;
